import request from 'request/index'
import { E_PRODUCT2_RES } from 'utils/config'
export default {
  /**
   *  3.3.2 获取标签列表 [get] /visitor/system_flag?$count=false&$offset=偏移量&$limit=数量&update_time=1231234512345&language_id=32
   */
  sGetFlag ({
    $count = false,
    $offset,
    $limit,
    language_id = 1
  }) {
    return request({
      method: 'GET',
      res: E_PRODUCT2_RES,
      api: '/visitor/system_flag',
      query: {
        $count,
        $limit,
        $offset,
        language_id
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/edmodo/flag.js